import { motion } from 'framer-motion';
import { getClass } from '../../utils/arena/classes';
import { t } from '../../localization/t';
import ForgedButton from '../ui/ForgedButton';
import { RushGauge, FerocityGauge } from './BattlemageGauges';

const ACCENT = getClass('battlemage').accent;
// The board stays in view; only a soft fall-off behind the plates.
const BACKDROP = 'blur(6px) brightness(0.85)';

// The pledge, at setup: the stacks at risk over the blurred board, pledge
// or fight unguarded under them, the Ferocity vial at the foot. Props carry
// the server view and the host's actions; this screen only asks.
export default function BattlemageOverlay({ standing, busy, error, onSeal }) {
  const float = (delay) => ({
    initial: { opacity: 0, y: '1.2cqw' },
    animate: { opacity: 1, y: 0 },
    transition: { type: 'spring', duration: 0.45, bounce: 0, delay },
  });
  return (
    <motion.div
      className="fixed inset-0 z-[1150] flex flex-col items-center justify-center"
      style={{
        gap: '2cqw',
        background: 'radial-gradient(ellipse 60% 55% at 50% 50%, rgba(0,0,0,0.38) 0%, rgba(0,0,0,0.12) 100%)',
        backdropFilter: BACKDROP,
        WebkitBackdropFilter: BACKDROP,
      }}
      initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}
      data-testid="battlemage-overlay"
    >
      <motion.div
        className="arena-heading font-bold"
        style={{ color: ACCENT, fontSize: '2.5cqw', lineHeight: 1.05, textShadow: `0 0.125cqw 0.5cqw rgba(0,0,0,0.85), 0 0 1.5cqw ${ACCENT}55` }}
        {...float(0)}
      >
        {t('Guard your Rush of Battle')}
      </motion.div>

      <motion.div {...float(0.12)}>
        <RushGauge rush={standing.rush} max={standing.rushMax} size={1.8} />
      </motion.div>

      <motion.div className="flex items-center" style={{ gap: '1.25cqw', marginTop: '0.5cqw' }} {...float(0.24)}>
        <motion.div whileTap={{ scale: 0.96 }} transition={{ type: 'spring', duration: 0.2, bounce: 0 }}>
          <ForgedButton className="px-6 py-3 text-[1.125cqw]" disabled={busy} onClick={() => onSeal(true)}>
            {t('Pledge {n} Ferocity', { n: standing.guardCost })}
          </ForgedButton>
        </motion.div>
        <motion.div whileTap={{ scale: 0.96 }} transition={{ type: 'spring', duration: 0.2, bounce: 0 }}>
          <ForgedButton tone="bronze" className="px-6 py-3 text-[1.125cqw]" disabled={busy} onClick={() => onSeal(false)}>
            {t('Fight unguarded')}
          </ForgedButton>
        </motion.div>
      </motion.div>
      {error ? <div style={{ color: '#e89090', fontSize: '0.8125cqw' }}>{error}</div> : null}

      <motion.div className="absolute left-1/2 -translate-x-1/2" style={{ bottom: '3cqw' }} {...float(0.4)}>
        <FerocityGauge value={standing.ferocity} max={standing.ferocityMax} />
      </motion.div>
    </motion.div>
  );
}
